import { subscribe } from "../services/subscription";
import {requestTelegramWriteAccess} from "../services/telegramWebApp";

// handleSubscribe инкапсулирует полный процесс подписки пользователя:
// 1. Запрашивает разрешение на отправку уведомлений через VK Bridge.
// 2. В случае успеха, отправляет запрос на наш бэкенд для сохранения подписки.
export function handleSubscribe() {
    return new Promise((resolve, reject) => {
        requestTelegramWriteAccess().then((isAllowed) => {
            if (isAllowed) {
                return subscribe().then(() => {
                    resolve(true);
                }).catch(err => {
                    console.error('Backend subscription error:', err);
                    reject(err);
                });
            } else {
                reject({ message: "User denied Telegram write access" });
            }
        }).catch(error => {
            console.error('Telegram WebApp write access error:', error);
            reject(error);
        });
    });
}
